export default "__VITE_ASSET__B8ZZbecZ__ 100w";